import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { AliquotLocation } from '../../core/api/lab.types';

export const hasErrorSelector = (state: RootState): boolean =>
  state.aliquotLocations.errors && state.aliquotLocations.errors ? true : false;

export const isBusySelector = (state: RootState): boolean => state.aliquotLocations.status === StoreStatus.BUSY;

export const searchTermSelector = (state: RootState): string | null =>
  state.aliquotLocations.values?.searchTerm || null;

export const responseSelector = (state: RootState): AliquotLocation[] | null => state.aliquotLocations.response || null;
